import { createRouter, createWebHistory } from "vue-router";
import AppHeader from "./layout/AppHeader";
import AppFooter from "./layout/AppFooter";
import Top from "@/views/Top";
import Contact from "@/views/Contact";
import Events from "@/views/Events";
import Books from "@/views/Books";
import Anthology from "@/views/Anthology";
import BookDetail from "@/views/BookDetail";
import EventDetail from "@/views/EventDetail";
import News from "@/views/News";
import FAQ from "@/views/FAQ";

const router = createRouter({
  linkExactActiveClass: "active",
  history: createWebHistory(process.env.BASE_URL),
  routes: [
    {
      path: "/",
      name: "home",
      components: { header: AppHeader, default: Top, footer: AppFooter },
      meta: { title: 'Home' }
    },
    {
      path: "/faq",
      name: "faq",
      components: { header: AppHeader, default: FAQ, footer: AppFooter },
      meta: { title: 'FAQ' }
    },
    {
      path: "/contact",
      name: "contact",
      components: { header: AppHeader, default: Contact, footer: AppFooter },
      meta: { title: '問合せ' }
    },
    {
      path: "/events",
      name: "events",
      components: { header: AppHeader, default: Events, footer: AppFooter },
      meta: { title: '即売会参加情報' }
    },
    {
      path: "/eventDetail/:id",
      name: "eventDetail",
      components: { header: AppHeader, default: EventDetail, footer: AppFooter },
      meta: { title: 'イベント詳細情報' }
    },
    {
      path: "/books",
      name: "books",
      components: { header: AppHeader, default: Books, footer: AppFooter },
      meta: { title: '個人誌一覧' }
    },
    {
      path: "/anthologies",
      name: "anthologies",
      components: { header: AppHeader, default: Anthology, footer: AppFooter },
      meta: { title: '合同誌・アンソロジー一覧' }
    },
    {
      path: "/bookDetail/:id",
      name: "bookDetail",
      components: { header: AppHeader, default: BookDetail, footer: AppFooter },
      meta: { title: '書籍詳細情報' }
    },
    {
      path: "/news",
      name: "news",
      components: { header: AppHeader, default: News, footer: AppFooter },
      meta: { title: 'お知らせ' }
    },
  ],
  scrollBehavior(to) {
    if (to.hash) {
      return { el: to.hash };   // Vue Router 4: selector → el
    } else {
      return { top: 0 };        // Vue Router 4: { x, y } → { left, top }
    }
  }
});

router.afterEach((to) => {
  document.title = '雛菊書房 - ' + to.meta.title;
});

export default router;